import { useRef } from 'react'
import { deepEqual } from 'Helper/deepEqual.js'

export function useDeepCompareMemoize(value) {
  const ref = useRef()
  // it can be done by using useMemo as well
  // but useRef is rather cleaner and easier

  if (!deepEqual(value, ref.current)) {
    ref.current = value
  }

  return ref.current
}

// see https://stackoverflow.com/questions/54095994/react-useeffect-comparing-objects
